import React from 'react';

import PropTypes from 'prop-types';
import * as style from './ArticleButtonGroup.module.scss';

const ArticleButtonGroup = (props) => {
  const { children, className } = props;

  return (
    <div className={`${style.articleButtonGroup} ${className}`}>{children}</div>
  );
};

ArticleButtonGroup.defaultProps = {
  className: '',
};

ArticleButtonGroup.propTypes = {
  className: PropTypes.string,
};

export default ArticleButtonGroup;
